import { Component, HostListener, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrl: './gauge-chart.component.scss',
})
export class GaugeChartComponent {
  @Input() loading = true;
  @Input() maxValue: number;
  @Input() currentValue: number;

  chartOption: echarts.EChartsOption;
  chartInstance: echarts.ECharts | null = null;

  isLoading = true;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateChartOptions();

    if (changes['loading']) {
      setTimeout(() => {
        this.isLoading = this.loading;
      }, 333);
    }
  }

  ngOnInit(): void {
    this.updateChartOptions();
  }

  buildSegmentColors(): [number, string][] {
    const N = 80;
    const segFill = 0.55; // 55% of each slot colored, 45% gap → finer dashes
    const max = this.maxValue || 60;
    const proportion = Math.min((this.currentValue || 0) / max, 1);
    const colors: [number, string][] = [];

    for (let i = 0; i < N; i++) {
      const slotStart = i / N;
      const segEnd = slotStart + segFill / N;
      const slotEnd = (i + 1) / N;
      const filled = slotStart < proportion;
      const color = filled ? '#3B82F6' : 'rgba(59, 130, 246, 0.15)';

      colors.push([Math.min(segEnd, 1), color]);
      colors.push([Math.min(slotEnd, 1), 'rgba(0,0,0,0)']);
    }
    return colors;
  }

  updateChartOptions() {
    this.chartOption = {
      series: [
        {
          type: 'gauge',
          startAngle: 210,
          endAngle: -30,
          min: 0,
          max: this.maxValue || 60,
          center: ['50%', '58%'],
          radius: '88%',
          progress: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              width: 10,
              color: this.buildSegmentColors(),
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            length: 6,
            distance: 14,
            lineStyle: {
              color: 'rgba(59, 130, 246, 0.35)',
              width: 1.5,
            },
          },
          axisLabel: {
            show: false,
          },
          pointer: {
            show: true,
            length: '55%',
            width: 2,
            itemStyle: {
              color: '#3B82F6',
            },
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 6,
            itemStyle: {
              color: '#3B82F6',
              borderWidth: 0,
            },
          },
          title: {
            show: false,
          },
          detail: {
            valueAnimation: true,
            fontSize: 40,
            fontFamily: 'Geist, sans-serif',
            fontWeight: 300,
            color: '#000000',
            offsetCenter: [0, '40%'],
          },
          data: [
            {
              value: this.currentValue || 0,
            },
          ],
        },
      ],
    };
  }

  ngOnDestroy(): void {}

  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
}
